import React from "react";
import { cn } from "@/lib/utils";

export function PageHeader({ title, eyebrow, description, actions, className, testId = "page-header" }) {
  return (
    <header
      className={cn("relative flex flex-col gap-4 pb-6 md:flex-row md:items-end md:justify-between", className)}
      data-testid={testId}
    >
      <div className="min-w-0">
        {eyebrow ? (
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">{eyebrow}</p>
        ) : null}
        <h1 className="text-xl font-semibold tracking-[-0.02em] leading-[1.3] text-1">{title}</h1>
        {description ? (
          <p className="mt-2 max-w-2xl text-[15px] text-slate-500 leading-[1.6]">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
